<div class="document" [ngStyle]="documentWidthStyle">
  <app-document-page-viewer chaseId="17010" [isMaximized]="true"></app-document-page-viewer>
</div>
<div class="separator" [ngStyle]="separatorLeftStyle" (mousedown)="startTrackingMouse($event)" (document:mouseup)="stopTrackingMouse()"></div>
<div class="empty-container"></div>
